import b2bService from '../api/b2b-service';
import Vue from "vue"

/**
 * B2B Store
 * */
export default {
    namespaced: true,
    state: () => {
        return {
            b2bLoading: false,
            b2bSuccess: true,
            b2bMessage: "",
            b2bError: null
        }
    },
    getters: {},
    mutations: {
        setLoading(state, val) {
            state.b2bLoading = val;
        },
        setSuccess(state, val) {
            state.b2bSuccess = val;
        },
        setMessage(state, val) {
            state.b2bMessage = val;
        },
        setError(state, val) {
            state.b2bError = val;
        },
        reset(state) {
            state.b2bLoading = false;
            state.b2bSuccess = true;
            state.b2bMessage = "";
            state.b2bError = null;
        }
    },
    actions: {
        /**
         * For B2B Corporate User to authenticate the access code and access the corporate website
         * */
        async authenticateAccessCode({commit}, data) {
            commit('reset');
            commit('setLoading', true);
            try {
                let res = await b2bService.authAccessCode(data);
                Vue.$log.info('res', res)
                if (res.code === 200) {
                    commit('setSuccess', true);
                    commit('setMessage', "Access code successfully applied");
                } else {
                    commit('setSuccess', false);
                    commit('setMessage', res.message)
                }
            } catch (err) {
                commit('setSuccess', false);
                commit('setMessage', "An error occurred. please try again later")
            } finally {
                commit('setLoading', false);
            }
        }
    },
    modules: {}
}
